import state from './state.js'

// Appearance (auto/light/dark). index.html sets data-theme before first paint
// from the same setting, so there's no flash.

const ACCENT = {light: '#1693d4', dark: '#3fb4ec'} // the logo's cyan: deeper on light, lighter on dark
// The installed app's window/status bar sits over the map, so by default it takes the color of the map showing
// (its land, woods and all, about): a dark bar over a light map stood out. Or (settings.barColor 'appearance')
// the sheets' color, light or dark. index.html has these too.
export const MAP_BAR = {light: '#e4e8da', dark: '#1f2327', satellite: '#2b3125'}
const SHEET_BAR = {light: '#f2f2f7', dark: '#1c1c1e'} // --sheet-bg

const darkQuery = matchMedia('(prefers-color-scheme: dark)')

function resolve(){
	const a = state.settings.appearance || 'auto'
	return a == 'auto' ? (darkQuery.matches ? 'dark' : 'light') : a
}

function rgba(hex, alpha){
	const n = parseInt(hex.slice(1), 16)
	return `rgba(${n >> 16}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`
}

export function applyTheme(){
	const theme = resolve()
	const root = document.documentElement
	root.dataset.theme = theme

	const color = ACCENT[theme]
	root.style.setProperty('--accent', color)
	root.style.setProperty('--accent-soft', rgba(color, theme == 'dark' ? .22 : .12))

	// the installed app's window/status bar: the map's color (its style, or Match: the appearance's), or the sheets'
	const map = state.settings.mapStyle == 'auto' ? theme : state.settings.mapStyle
	const bar = state.settings.barColor == 'appearance' ? SHEET_BAR[theme] : MAP_BAR[map] || MAP_BAR.light
	document.querySelectorAll('meta[name="theme-color"]').forEach(m=>m.content = bar)

	if( theme != state.theme ){
		state.theme = theme
		state.emit('theme')
	}
}

state.addEventListener('settings', applyTheme)
darkQuery.addEventListener('change', applyTheme)
applyTheme()
